import {TransportModeSelectItem} from './transport-mode-select-item';

export const TRANSPORT_MODE_SELECT_DATA: TransportModeSelectItem[] = [
  {
    id: 'Rail',
    label: 'Rail',
  },

  {
    id: 'Road',
    label: 'Road',
  },

  {
    id: 'Water',
    label: 'Water',
  },

  {
    id: 'Air',
    label: 'Air',
  },
];
